import { agentOrderActionTypes } from "../../actionTypes/agentOrder/agentOrder.actionTypes";
import { AGENT_ORDER_STORAGE_KEY } from "../../../middlewares/agentOrder/agentOrder.middleware";

// 0017: hydrate the selected customer from localStorage so the on-behalf context (and the bar)
// survive a page refresh. Mirrors the cart's loadCartStateFromLocalStorage pattern.
const loadAgentOrderStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem(AGENT_ORDER_STORAGE_KEY);
    return serializedState ? JSON.parse(serializedState) : undefined;
  } catch (err) {
    console.error("Failed to load agent-order state from localStorage:", err);
    return undefined;
  }
};

const initialState = loadAgentOrderStateFromLocalStorage() || {
  // The business customer the agent/admin is currently ordering on behalf of (null = none).
  selectedCustomer: null,
};

const agentOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case agentOrderActionTypes.SET_SELECTED_CUSTOMER:
      return { ...state, selectedCustomer: action.data };

    case agentOrderActionTypes.CLEAR_SELECTED_CUSTOMER:
      return { ...state, selectedCustomer: null };

    default:
      return state;
  }
};

export default agentOrderReducer;
